// src/features/tower/storeReadiness/components/EmployeeCarousel.tsx

import React from "react";
import type { EmployeeSummary, ReadinessPermissions } from "../types";
import { EmployeeCard } from "./EmployeeCard";

type Props = {
  employees: EmployeeSummary[];
  permissions: ReadinessPermissions;
  onRecalculated: () => void;
};

export function EmployeeCarousel({ employees, permissions, onRecalculated }: Props) {
  if (employees.length === 0) {
    return (
      <div style={{ fontSize: 13, color: "var(--ct-ink-3)", padding: "12px 0" }}>
        No active employees found for this branch.
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        gap: 10,
        overflowX: "auto",
        paddingBottom: 8,
        marginBottom: 20,
      }}
    >
      {employees.map((e) => (
        <EmployeeCard
          key={e.employeeId}
          employee={e}
          permissions={permissions}
          onRecalculated={onRecalculated}
        />
      ))}
    </div>
  );
}
